import { Vehicle } from '../types';

export const vehicles: Vehicle[] = [
  // Renault vehicles
  { id: 'renault-5', name: 'Renault 5', brand: 'renault', price: 30.00 },
  { id: 'renault-arkana', name: 'Renault Arkana', brand: 'renault', price: 30.00 },
  { id: 'renault-austral', name: 'Renault Austral', brand: 'renault', price: 30.00 },
  { id: 'renault-captur', name: 'Renault Captur II', brand: 'renault', price: 30.00 },
  { id: 'renault-clio', name: 'Renault Clio V', brand: 'renault', price: 30.00 },
  { id: 'renault-kangoo', name: 'Renault Kangoo PKW', brand: 'renault', price: 30.00 },
  { id: 'renault-kangoo-rapid', name: 'Renault Kangoo Rapid', brand: 'renault', price: 30.00 },
  { id: 'renault-master', name: 'Renault Master IV', brand: 'renault', price: 30.00 },
  { id: 'renault-megane', name: 'Renault Megane E-Tech', brand: 'renault', price: 30.00 },
  { id: 'renault-scenic', name: 'Renault Scenic E-Tech', brand: 'renault', price: 30.00 },
  { id: 'renault-symbioz', name: 'Renault Symbioz', brand: 'renault', price: 30.00 },
  
  // Dacia vehicles
  { id: 'dacia-bigster', name: 'Dacia Bigster', brand: 'dacia', price: 30.00 },
  { id: 'dacia-duster', name: 'Dacia Duster II', brand: 'dacia', price: 30.00 },
  { id: 'dacia-jogger', name: 'Dacia Jogger', brand: 'dacia', price: 30.00 },
  { id: 'dacia-sandero-stepway', name: 'Dacia Sandero-Stepway', brand: 'dacia', price: 30.00 },
  { id: 'dacia-sandero', name: 'Dacia Sandero', brand: 'dacia', price: 30.00 },
  { id: 'dacia-spring', name: 'Dacia Spring', brand: 'dacia', price: 30.00 },
];